import React, { useState } from 'react';
import { Icon, IconWeight } from '@phosphor-icons/react';
import classNames from 'classnames';

interface Props {
  Icon: Icon;
  weight?: IconWeight;
  size?: string;
  className?: string;
}

const HoverIcon: React.FC<Props> = (props) => {
  const { Icon, weight = 'regular', size = '1rem', className } = props;

  const [hovered, setHovered] = useState(false);

  return (
    <Icon
      weight={hovered ? 'fill' : weight}
      size={size}
      className={classNames('cursor-pointer transition-all', className)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    />
  );
};

export default HoverIcon;
